<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">送样日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.pi_date
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">送样单号</label>
            <span class="weui-form-preview__value">{{
              form.pi_inoutno
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{
              form.pi_custname
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">部门</label>
            <span class="weui-form-preview__value">{{
              form.pd_seller_dpname
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value">{{
              form.pd_sellername
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{
              form.pd_prodcode
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{
              form.pr_detail
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{
              form.pr_orispeccode
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{ form.pr_spec }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{
              form.pr_brand
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出货数</label>
            <span class="weui-form-preview__value"
              >{{ form.pd_outqty }}{{ form.pr_unit }}</span
            >
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">辅助数量</label>
            <span class="weui-form-preview__value">{{
              form.pd_qty_extra
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系人</label>
            <span class="weui-form-preview__value">{{
              form.pi_contact
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系电话</label>
            <span class="weui-form-preview__value">{{ form.pi_tel }}</span>
          </div>
        </div>

        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">认证状态</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.pda_status"
              placeholder="请选择"
            >
              <option value="1">认证通过</option>
              <option value="2">认证失败</option>
            </select>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">研发确认联系人</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.pda_contact"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">联系电话</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.pda_tel"
              placeholder="请填写"
            />
          </div>
        </div>
        <date-field label="认证日期" v-model="form.pda_date" />
        <div class="weui-cell" slot="pd_outqty">
          <div class="weui-cell__hd">
            <label for class="weui-label">证书编号</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.pda_ertificateno"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">问题描述</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.pda_remark"
              placeholder="请填写"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="weui-cells__group">
      <div class="weui-cells__title">附件</div>
      <div class="weui-cells">
        <file-field v-model="form.pda_attach" ref="pda_attach" />
      </div>
    </div>
    <div style="height: 50px"></div>
    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import FileField from "@/components/field/FileField.vue";
import DateField from "@/components/field/DateField.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    FileField,
    DateField,
  },
  props: {
    initData: Object,
  },
  data() {
    return {
      form: {},
      caller: "SaleOutSample",
    };
  },
  mounted() {
   this.getData();
  },
  methods: {
    getData() {
      let me = this,
      form = me.initData;
      form.pda_attach = me.initData.pda_attach;
      me.$refs.pda_attach.loadData()
    },
    /**
     * 认证
     */
    save() {
      var me = this,
        form = me.form,
        list = [];
      list.push(form);

      me.$loading({
        url: "/api/sale/prodinout/saveSample",
        method: "POST",
        jsonData: {
          list: list,
        },
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("保存成功", 2000);
          me.$router.back();
        } else {
          me.$weui.topTips(res.message || "提交失败", 3000);
        }
      });
    },
  },
};
</script>